import { IReportSet } from '../../state/types';
import { makeSourceSetElementFetch } from './_shared/fetchMakers';
import { normalizeAndTranslateSingleEntity } from './_shared/normalizers';
import { makeGenericUrl } from './_shared/urlMakers';

export const fetchSourceSetElement = makeSourceSetElementFetch<IReportSet>(
    makeGenericUrl,
    normalizeAndTranslateSingleEntity
);
